// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"78174775","142":"43cd20c7","422":"7c08a576","506":"60dcaed7","848":"be3dc280","878":"7b5fb382"}[chunkId] + ".chunk.js";
};